// packages/web/src/components/account/auth-signup-sent-view.tsx
/**
 * SignupSentView — "verification email sent" confirmation (19BO+ Phase B).
 *
 * Shown after the signup REQUEST stage succeeds. Mirrors the magic-link
 * 'sent' step visually (same .auth-magic-sent styles) so the two email-based
 * flows feel consistent. The user clicks the link in their email to complete
 * stage 2; this view just confirms the email is on its way + offers a way
 * back to login.
 *
 * No resend button here (unlike magic-link) — the per-email rate limit
 * (3/min) makes a quick resend likely to 429, and the user can always
 * re-submit the signup form. Keeping the UI honest about that.
 */

import { useT } from '../../i18n/use-t.js';
import type { AuthMode } from './auth-modal.js';

interface Props {
  onSwitchMode: (m: AuthMode) => void;
}

export function AuthSignupSentView({ onSwitchMode }: Props) {
  const t = useT();
  return (
    <>
      <div className="auth-head">
        <span className="auth-head-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
            <rect width="20" height="16" x="2" y="4" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
        </span>
        <h2>{t('auth.createAccount')}</h2>
      </div>
      <div className="auth-body">
        <div className="auth-magic-sent">
          <div className="auth-magic-sent-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="26" height="26">
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
          </div>
          <h3>{t('auth.signupSent')}</h3>
          <p className="auth-magic-sent-hint">{t('auth.signupSentHint')}</p>
          <div className="auth-switch" style={{ marginTop: 'var(--space-2xl)' }}>
            <button type="button" onClick={() => onSwitchMode('login')}>← {t('auth.welcome')}</button>
          </div>
        </div>
      </div>
    </>
  );
}
